module.exports = __webpack_public_path__ + "static/img/3.5e9aee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/afterSale/3.jpg
// module id = T0yd
// module chunks = 1